import React from 'react';
import { useParams } from 'react-router-dom';
import { GuestRequestReturnForm } from '../../components/GuestRequestReturnForm';
import { PageMeta } from '../../components/PageMeta';
import { RequestReturnForm } from '../../components/RequestReturnForm';

export const GuestRequestReturnPage = () => {
  const { orderNumber } = useParams<{ orderNumber?: string }>();

  if (!orderNumber) {
    return (
      <>
        <PageMeta title="Guest Request Return" />

        <GuestRequestReturnForm />
      </>
    );
  }

  return <RequestReturnForm />;
};
